export default "__VITE_ASSET__BgfMSSfY__"